import { render, staticRenderFns } from "./b-section-subtitle.global.vue?vue&type=template&id=83191928"
import script from "./b-section-subtitle.global.vue?vue&type=script&lang=js"
export * from "./b-section-subtitle.global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports